import { SearchResponse } from '@algolia/client-search';
import {
	mapKeywordSearchLabels,
	mapPostTypeLabels,
	searchKeywordTarget,
} from '.';
import { IDefaultSearchResult } from '../algolia';
import { FacetFilters } from '../algolia/FacetFilters';
import { FacetFiltersSelect } from '../algolia/FacetFiltersSelect';
import { FacetList } from '../algolia/FacetsList';
import { FacetTabs } from '../algolia/FacetTabs';
import { KeywordInput } from '../algolia/KeywordInput';
import { SearchCount } from '../algolia/SearchCount';
import { SearchDisplay } from '../algolia/SearchDisplay';
import { ISearchParams, SearchService } from '../algolia/SearchService';

type TSearchFacets = 'search_post_type' | 'taxonomies.service_topics' | 'taxonomies.search_tags';

const defaultSearchParams: ISearchParams<TSearchFacets> = {
	textSearch: '',
	facets: ['search_post_type', 'taxonomies.service_topics', 'taxonomies.search_tags'],
	countFacets: ['search_post_type'],
	facetsData: {
		search_post_type: ['-suburbs'],
		'taxonomies.service_topics':[],
		'taxonomies.search_tags':[],
	},
};

let searchService: SearchService<TSearchFacets, IDefaultSearchResult>;

export async function initSearch() {
	const $searchContainer = $(searchKeywordTarget);
	const $resultsContainer = $('[data-search-results]', $searchContainer);
	const $resultsCount = $('[data-search-count]', $searchContainer);
	const $facetsList = $('[data-search-facets-list]', $searchContainer);
	const $searchInput = $('[data-search-input]', $searchContainer);
	const $searchDisplay = $('[data-search-display]', $searchContainer);
	const $facetTabs = $('[data-facet-tabs]', $searchContainer);
	const $facetFilters = $('[data-facet-filters]', $searchContainer);
	const $facetFiltersSelect = $(
		'[data-facet-filters-select]',
		$searchContainer,
	);
	let isInitialised = false;

	if ($searchContainer.length) {
		// Handle the modal closing
		$searchContainer
			.parents('.search_keyword')
			.on('modal:active', () => {
				if (!isInitialised) {
					// Set up algolia search
					searchService = new SearchService<
						TSearchFacets,
						IDefaultSearchResult
					>({
						indexName: algolia.indices.searchable_posts.name,
						defaultSearchParams,
					});

					if ($resultsCount.length) {
						new SearchCount(
							$resultsCount,
							searchService,
							'Showing {####} results',
						);
					}

					if ($facetsList.length) {
						new FacetList(
							$facetsList,
							searchService,
							[],
							'&nbsp;for&nbsp;',
						);
					}

					if ($facetTabs.length) {
						$facetTabs.each((_index, element) => {
							const $element = $(element);
							new FacetTabs(
								$element,
								searchService,
								$element.attr('data-facet-tabs'),
							);
						});
					}

					if ($searchDisplay.length) {
						new SearchDisplay($searchDisplay, searchService);
					}

					if ($searchInput.length) {
						new KeywordInput($searchInput, searchService);
					}

					if ($facetFilters.length) {
						new FacetFilters(
							$facetFilters,
							searchService,
							'search_post_type',
							mapKeywordSearchLabels,
						);
					}

					if ($facetFiltersSelect.length) {
						new FacetFiltersSelect(
							$facetFiltersSelect,
							searchService,
							'search_post_type',
							mapKeywordSearchLabels,
						);
					}

					searchService.addResultsListener((results) => {
						if ($resultsContainer.length) {
							displayResults($resultsContainer, results);
						}
					});

					searchService.loadPage(0);

					isInitialised = true;
				}
			})
			.on('modal:closed', () => {
				// Reset the search
				searchService.searchParams = defaultSearchParams;
				$('input', $searchInput).val('');
			});
	}
}

function displayResults(
	$resultsContainer: JQuery<HTMLElement>,
	result: SearchResponse<IDefaultSearchResult>,
) {
	let content = '';

	if (result.hits.length) {
		content = result.hits
			.map((hit) => {
				const postType = mapPostTypeLabels.has(hit.search_post_type)
					? mapPostTypeLabels.get(hit.search_post_type)
					: hit.search_post_type;

				let postTypeLabel = `<span>${postType}</span>`;

				return `
				<div class="search-item-result">
					<a class="search_result-link" href="${hit.permalink}">
						<div class="search-item-result-content">
							<div class="search_result-breadcrumb">${postTypeLabel}</div>
							<div class="search_result-title"><span>${hit._highlightResult.post_title.value}<span></div>
						</div>
					</a>
				</div>
				`;
			})
			.join('');
	} else {
		// TODO no results
	}

	$resultsContainer.empty().append(content);
}



// WEBPACK FOOTER //
// ./scripts/components/searchKeyword.ts